import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/duplicates/translation.link.mutation.gql"
import type {
  TranslationLinkMutation,
  TranslationLinkMutationVariables,
} from "@/v2-backoffice-client/translation/duplicates/__types__/translation.link.mutation"

type Options = MutationHookOptions<
  TranslationLinkMutation,
  TranslationLinkMutationVariables
>

export function useTranslationLinkMutation(options?: Options) {
  return useMutation<TranslationLinkMutation, TranslationLinkMutationVariables>(
    mutation,
    {
      refetchQueries: ["TranslationCatalogQuery"],
      ...options,
    },
  )
}
